import plugin, { TurboMount } from "turbo-mount/react"
import { registerComponents } from "turbo-mount/registerComponents/esbuild"
import { application } from "./controllers/application"
import components from "./components/**/*.js"

export const turboMount = new TurboMount({ application })

registerComponents({
  plugin,
  turboMount,
  components
})
